import { Injectable } from '@angular/core';


@Injectable({ providedIn: 'root' })
export class BusyService {
  public busyPromise: Promise<any> | undefined;
  private _busyCount = 0;

  public isBusy() {
    return this.busyPromise != null || this._busyCount > 0;
  }


  public async wrapBusy<T>(op: Promise<T> | (() => Promise<T>)): Promise<T> {
    if (this.busyPromise) {
      return await (typeof op === 'function' ? op() : op);
    }

    try {
      this.busyPromise = typeof op === 'function' ? op() : op;
      return await this.busyPromise;
    } finally {
      this.busyPromise = undefined;
    }
  }



}
